import { type Enum } from '@webapp/infrastructure/types/Enum'

// Export-task lifecycle. Drives the Export History Status cell
// (spinner / Download link / Failed) and the progress modal's
// completion state (BHV-032, BHV-036).
export const ExportTaskStatuses = {
  PREPARING: 0, // CSV build in progress — spinner
  READY: 1, // File generated — Download link to /api/v3/attachments/{file.uuid}
  FAILED: 2, // Build failed — "Failed" label
} as const

export type ExportTaskStatus = Enum<typeof ExportTaskStatuses>
